import { useSelector } from 'react-redux'
import { get, has, isEmpty, map, unescape } from 'lodash'

import { getAccommodation, getAccommodationLoading } from '../../redux/reducers/accommodation'
import Gallery from '../../components/elements/Gallery'
import Features from '../../components/elements/Features'
import LoadingSpinner from '../../components/elements/LoadingSpinner'

import '../../styles/scss/views/accommodations.scss'

function getAccommodationImages(accommodation) {
  if (has(accommodation, 'viewExtensions.images')) {
    return get(accommodation, 'viewExtensions.images')
  }
  // I'm leaving this in to support the prod cutover from the old images implementation
  // to the new one. Referencing anything but viewExtensions.images in the future will
  // not be necessary.
  const leonardoImages = get(accommodation, 'viewExtensions.leonardoImages', [])
  if (!isEmpty(leonardoImages)) {
    return map(leonardoImages)
  }
  if (!isEmpty(get(accommodation, 'images'))) {
    return map(get(accommodation, 'images', []), (item) => ({
      caption: '',
      url: get(item, 'path'),
    }))
  } 
  if (!isEmpty(get(accommodation, 'viewExtensions.kaptioImages'))) {
    return map(get(accommodation, 'viewExtensions.kaptioImages'), (item) => ({
      caption: '',
      url: get(item, 'path'),
    }))
  } 
  if (get(accommodation, 'defaultImage')) {
    return [{
      caption: '',
      url: get(accommodation, 'defaultImage.path')
    }]
  }
  return []
}

const AccommodationsContainer = () => {
  const accommodationDataLoading = useSelector((state)=> getAccommodationLoading(state))
  const accommodationData = useSelector((state) => getAccommodation(state))

  if (accommodationDataLoading) {
    return (
      <div className="accommodations">
       <LoadingSpinner />
      </div>
    )
  }
  if (!accommodationData) return null

  const northstar = get(accommodationData, 'viewExtensions.northstar')
  const hotelName = get(northstar, 'HotelName') || get(accommodationData, 'name')
  const hotelDescription =
    get(accommodationData, 'description') ||
    get(northstar, 'HotelDescription')
  const images = getAccommodationImages(accommodationData)
  const displayItineraryFlag = get(accommodationData, 'viewExtensions.itineraryFlag')
  const itineraryFlagText = get(accommodationData, 'viewExtensions.itineraryText')
  const isLeonardoPhotos = get(accommodationData, 'viewExtensions.imagesSourcedFrom') === 'leonardo'
    || has(accommodationData, 'viewExtensions.leonardoImages')

  return (
    <div className="accommodations">
      {!isEmpty(images) && (
        <Gallery
          isLeonardoPhotos={isLeonardoPhotos}
          itineraryFlag={displayItineraryFlag && itineraryFlagText}
          photos={images}
        />
      )}
      {hotelName && (
        <div className="content-container">
          <section className="content-section">
            <div className="sticky-content">
              <h1 className="title">{unescape(hotelName)}</h1>
              <p
                className="description"
                dangerouslySetInnerHTML={{
                  __html: unescape(hotelDescription),
                }}
              />
            </div>
          </section>
          <section className="content-section">
            <Features accommodation={accommodationData} />
          </section>
        </div>
      )}
    </div>
  )
}

export default AccommodationsContainer
